namespace GeniuzPOS.AdvPromo {
    export interface PsPromoAvDaysRow {
        Id?: number;
        PmGroupId?: string;
        PromoDay?: number;
    }

    export namespace PsPromoAvDaysRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PmGroupId';
        export const localTextPrefix = 'AdvPromo.PsPromoAvDays';
        export const lookupKey = 'AdvPromo.PsPromoAvDays';

        export function getLookup(): Q.Lookup<PsPromoAvDaysRow> {
            return Q.getLookup<PsPromoAvDaysRow>('AdvPromo.PsPromoAvDays');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PmGroupId = "PmGroupId",
            PromoDay = "PromoDay"
        }
    }
}
